var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "action-pane-wrapper", attrs: { id: "checklist-tab" } },
    [
      _c(
        "div",
        { staticClass: "h-100 d-flex", attrs: { id: "checklist-input" } },
        [
          _c(
            "div",
            { staticClass: "w-100" },
            [
              _c("checklist-component", {
                attrs: { title: _vm.title, checklist: _vm.checklist },
                on: { input: _vm.handleUpdate },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "simple-button",
            {
              attrs: {
                type: "primary",
                "class-name": "btn-sm ml-2 align-self-end",
                disabled: !_vm.checklist.length,
                loading: _vm.loading,
                "loading-succeeded": _vm.loadingSucceeded,
              },
              on: { click: _vm.handleSubmit },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("client-profile.actions.saveChecklist")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }